import * as React from 'react';
import { Button } from '@one-thd/sui-atomic-components';
import * as utils from './Utils';

export const Purchaser = () => {

  const returnToOrigin = () => {
    const redirectUrl = utils.getOriginPageUrl();
    const defaultOrigin = window.location.origin + '/c/Credit_Center';
    window.location.href = redirectUrl || defaultOrigin;
  };

  return (
    <div className="purchaser-container sui-m-10">
      <img
        src="https://assets.homedepot-static.com/images/v1/hd-logo.svg"
        className="sui-pb-5 hd-logo-image"
        alt="Home Depot Logo"
        height="80px"
        width="80"
      />
      <p className="sui-font-display sui-text-4xl sui-pb-3">Authorization Required</p>
      <p className="sui-pb-5 sui-text-lg sui-text-left">
        You’re designated as a Purchaser on this business account. Only Admins on this account can
        apply for a ProXtra Credit Card. Get an Admin to apply for the card, or have them change
        your account role so you can apply.
      </p>
      <Button onClick={returnToOrigin} fullWidth>Got It</Button>
    </div>
  );
};

Purchaser.displayName = 'Purchaser';
